(function() {
  // Move #FacetFiltersContainer into .ed_collection_filters_wrapper on collections
  // and keep it there in Shopify theme editor after any section/block changes.
  // Developer: Rana
  'use strict';
  
  function moveFiltersContainer() {
    const filtersWrapper = document.querySelector('.ed_collection_filters_wrapper');
    if (!filtersWrapper) return;

    const containers = document.querySelectorAll('#FacetFiltersContainer');
    if (!containers.length) return;

    const containersArray = Array.from(containers);

    let primary = containersArray.find(function(container) {
      return filtersWrapper.contains(container);
    });

    if (!primary) {
      primary = containersArray[0];
      filtersWrapper.appendChild(primary);
    }

    containersArray.forEach(function(container) {
      if (container === primary) return;

      if (container.innerHTML && container.innerHTML.trim().length > 0) {
        primary.innerHTML = container.innerHTML;
      }

      container.parentNode && container.parentNode.removeChild(container);
    });
  }
  
  let debounceTimer;
  function debouncedMoveFiltersContainer() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(moveFiltersContainer, 50);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFiltersContainer, { once: true });
  } else {
    moveFiltersContainer();
  }
  
  document.addEventListener('shopify:section:load', function(event) {
    setTimeout(moveFiltersContainer, 0);
  });
  
  document.addEventListener('shopify:section:select', function(event) {
    moveFiltersContainer();
  });
  
  document.addEventListener('shopify:section:deselect', function(event) {
    debouncedMoveFiltersContainer();
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    setTimeout(moveFiltersContainer, 100);
  });
  
  document.addEventListener('shopify:section:reorder', function(event) {
    debouncedMoveFiltersContainer();
  });
  
  document.addEventListener('shopify:block:select', function(event) {
    debouncedMoveFiltersContainer();
  });
  
  document.addEventListener('shopify:block:deselect', function(event) {
    debouncedMoveFiltersContainer();
  });
  
  document.addEventListener('facet:updated', moveFiltersContainer);
  document.addEventListener('facet:reload', moveFiltersContainer);
  
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      const filtersWrapper = document.querySelector('.ed_collection_filters_wrapper');
      const filtersContainer = document.getElementById('FacetFiltersContainer');
      
      if (filtersWrapper && filtersContainer && !filtersWrapper.contains(filtersContainer)) {
        debouncedMoveFiltersContainer();
      }
    });
    
    function initObserver() {
      const targetNode = document.body || document.documentElement;
      if (targetNode) {
        observer.observe(targetNode, {
          childList: true,
          subtree: true,
          attributes: false
        });
      }
      
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        observer.observe(mainContent, {
          childList: true,
          subtree: true
        });
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initObserver, { once: true });
    } else {
      initObserver();
    }
  }
  
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    const customizerInterval = setInterval(function() {
      const filtersWrapper = document.querySelector('.ed_collection_filters_wrapper');
      const filtersContainer = document.getElementById('FacetFiltersContainer');
      
      if (filtersWrapper && filtersContainer && !filtersWrapper.contains(filtersContainer)) {
        moveFiltersContainer();
      }
    }, 500);
    
    // Clean up interval when leaving customizer (if possible)
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        clearInterval(customizerInterval);
      }
    });
  }
})();

